module.exports = {
  "default": require("core-js/library/fn/object/keys"),
  __esModule: true
};